import { combineReducers } from 'redux';

import { reducer as user } from './User';
import { reducer as wellGuardian } from './WellGuardian';

export default combineReducers({
  user,
  wellGuardian,
});
